export default "/public/dist/img/img_n4.jpg";